import Main from './Main.vue'

export default [{
  path: 'pregao-leiloeiro/:id',
  name: 'pregaoleiloeiro',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-leiloeiro/routes.js